<template>
  <main class="page-padding page-sidebar roles-page"
        :class="{'roles-page_full': !sidebarOpen}">
    <div class="roles-wrap">
      <all-projects-navigator @close="toggleOpenNavigator(false)"
                              @open="toggleOpenNavigator(true)"
                              @clickInNode="clickInNavigatorNode"
                              navigator-link="/roles"
                              :subheader-text="$t('roles.allRoles')"
                              :isOpen="openNavigator">
        <roles-icon fill="#109CF1"></roles-icon>
      </all-projects-navigator>
      <div class="roles-right"
           v-if="isMotherPage"
           :class="{'roles-right_full': !openNavigator}">
        <roles-header @del="emitDel"></roles-header>
        <roles-single :del="delRoles"></roles-single>
      </div>
      <router-view></router-view>
    </div>
    <p class="btn-hint name-hint btn-hint_bottom btn-hint-navigator">

    </p>
  </main>
</template>

<script>
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'

  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
  import {hideRoles} from "../../mixins/roles/hideRoles";
  import {generateGrid} from "../../mixins/generateGrid";
  import {loaderMixin} from "../../mixins/utils/loaderMixin";
  import {sidebarState} from "../../mixins/utils/sidebarState";
  import {projectsNavigator} from "../../mixins/utils/projectsNavigator";

  import rolesSingle from '../../components/Pages/Roles/rolesSingle'

  import rolesHeader from '../../components/Pages/Roles/rolesHeader'
  import rolesIcon from '../../components/Svg/users/group'


  export default {
    name: 'users',
    mixins: [tokenAndRoute,hideRoles,generateGrid, loaderMixin, sidebarState, projectsNavigator],
    components: {
      rolesSingle,
      rolesHeader,
      rolesIcon
    },
    data() {
      return {
        isCheckAllSingle: false,
        checkedRolesSingle: [],
        layoutSingle: [],
        layoutGroups: [],
        delRoles: false,
      }
    },
    computed: {
      ...mapGetters({
        adminRole: 'auth/adminRole'
      }),
      isMotherPage() {
        return this.$route.name === 'roles'
      }
    },
    methods: {
      ...mapMutations({
        setFullSidebar: 'sidebar/SET_DASHBOARD',
        setLinkName: 'sidebar/SET_LINK_NAME',
        setRouteName: 'sidebar/SET_ROUTE_NAME',
        setDirName: 'roles/SET_DIR_NAME'
      }),
      ...mapActions({
        getOwnedRoles: 'roles/getOwnedRoles',
        getUsers: 'roles/getUsers',
        getProjects: 'projects/getProjects',
      }),
      clickInNavigatorNode(node) {
        let id = node.id;
        this.setDirName(node.name);
        let projectId;
        let treeItem;
        let findParent = (item) => {
          treeItem = item.parent;
          if (item.parent.id !== 0) {
            projectId = item.parent.id;
            findParent(treeItem)
          }
        };
        findParent(node);

        if (node.isMother) {
          this.$router.push(`/roles/project/${id}`)
        } else {
          this.$router.push(`/roles/project/${projectId}/project-item/${id}`)
        }

      },
      emitDel() {
        this.delRoles = true;

        setTimeout(() => {
          this.delRoles = false
        }, 100)
      }
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        const token = localStorage.getItem('token');
        if (token) {
          vm.showLoader();
          await vm.getOwnedRoles({token, id: ''});
          await vm.getUsers(token);
          await vm.getProjects();
          vm.setFullSidebar(true);
          vm.setRouteName('');
          vm.hideLoader();
        };

        if (!vm.adminRole) {
          vm.$router.push('/403');
        }
      });
    },
  }
</script>

<style lang="scss" >
  .roles-page {
    display: flex;
    flex-direction: column;
    padding-top: 90px!important;
    padding-left: 240px;
    padding-right: 30px;

    .roles-right {
      flex-grow: 1;
      margin-left: 300px;

      @media screen and (max-width: 1500px) {
        margin-left: 250px;
      }
    }

    .roles-right_full {
      margin-left: 70px;
    }

    .roles-wrap {
      display: flex;
    }

    .controls-cont {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -5px;
    }

    .control-item {
      margin: 0 5px;
    }

    .group-fast-menu {
      margin-left: auto;
    }

    .avatar-wrap {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: $lightGrey;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .cart-bottom {
      position: relative;

      &:hover {

      }
    }

    .control-item_group {
      &:hover {
        svg path {
          fill: $darkBlue;
        }
      }

      &.del-item:hover {
        color: $red;

        svg path {
          fill: $red;
        }
      }
    }

    .group-fast-menu {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;

      &:hover {
        background: $grey;

        svg path {
          fill: white;
        }
      }
    }

    .group-fast-menu_active {
      background: $grey;

      svg path {
        fill: white;
      }
    }

    .group-item {
      cursor: default;

      &:hover {
        z-index: 10;
      }
    }

    .title {
      font-family: $msb;
      font-size: 18px;
      letter-spacing: .25px;
      color: $darkBlue;
    }

    .single-list-legend {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    .cell1 {
      width: 38px;
      margin-right: 8px;
      min-height: 16px;
      display: flex;

      .check-cont {
        display: flex;
        justify-content: flex-end;
      }

      .check-label {
        padding: 0;

        &::before {
          border: 2px solid $grey;
          width: 12px;
          height: 12px;
          top: calc(50% - 9px);
        }
      }
    }

    .cell2 {
      width: 154px;
      padding-right: 10px;
      font-family: $mm;
      font-size: 14px;
      letter-spacing: .25px;
      color: $darkBlue;
    }

    .cell3 {
      width: 159px;
      display: flex;
      align-items: center;
      padding-right: 20px;

      .edit-single-role {
        margin-left: auto;

        &:hover {
          svg path {
            fill: $darkBlue;
          }
        }
      }
    }



    .legend {
      font-family: $mr;
      font-size: 13px;
      color: $darkBlue;
      opacity: .5;

    }

    .sigle-list {
      margin: 0 -10px;
    }

    .single-list_item {
      display: flex;
      width: 100%;
      align-items: center;
      margin-bottom: 5px;
      background: rgba(215, 227, 234, .5);
      border-radius: 6px;

      &:hover {
        background: white;
        box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
      }

      &.hiddenClass {
        visibility: hidden!important;
      }

      &.single-list_item_hide {
        display: none!important;
      }
    }

    .avatar-list {
      width: 100%;
      margin: 0 -5px;
      display: flex;
      align-items: center;
    }

    .avatar-cont {
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: rgba(215, 227, 234, 1);
      margin: 0 5px;
      background-size: contain;
      overflow: hidden;

      .img-cont {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 3px;

        svg {
          max-width: 100%;
          height: auto;
        }
      }
    }
  }
</style>
